:host {
  display: block;
  background: transparent !important;
}

.playlist__base {
  container-type: inline-size;
}

::slotted([provider='audio']) {
  flex: 1;
  box-sizing: border-box;
  flex: 0 0 100%;
  min-height: 300px;
}

.playlist {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  border-radius: var(--presto-playlist-border-radius, 8px);
  overflow: hidden;
  border-width: var(--presto-playlist-border-width, 1px);
  border-style: solid;
  border-color: var(--presto-playlist-border-color, #ddd);
  background: var(--presto-playlist-background-color, #fff);
  position: relative;

  &__base {
    user-select: none;
  }

  &__preview {
    position: relative;
    flex: 1;
  }

  &__info {
    border-radius: 8px;
    overflow-y: scroll;
    min-width: 300px;
    max-width: 350px;
    width: 30%;
    display: flex;
    flex-direction: column;
    overflow: auto;

    &--inner {
      flex: 1 1 1px;
      overflow: auto;
      margin: 30px;
      margin-top: 0;
      margin-right: 15px;
      padding-right: 15px;
      height: fit-content;
      min-height: 175px;

      .playlist__list {
        gap: var(--presto-playlist-gap, 10px);
        display: flex;
        flex-direction: column;
      }

      &::-webkit-scrollbar {
        width: 6px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: #ddd;
        border-radius: 5px;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 5px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #aaa;
        border-radius: 5px;
      }
    }
  }

  &__heading {
    display: flex;
    justify-content: space-between;
    padding: 25px 30px 16px;
  }

  &__heading-title {
    font-size: 16px;
    font-weight: 500;
    color: var(--presto-playlist-text-color);
  }

  &__heading-count {
    color: var(--presto-playlist-text-color, var(--plyr-audio-control-color, #b1b1b1));
    font-size: 12px;
  }
}

/** Container query! */
@container (max-width: 782px) {
  .playlist {
    flex-direction: column;

    &__info {
      max-width: none;
      min-height: none;
      width: 100%;

      &--inner {
        flex: 1;
        height: fit-content;
        max-height: var(--presto-playlist-max-height-stacked, 200px);
        min-height: var(--presto-playlist-min-height-stacked, 0);
      }
    }

    &__preview {
      min-height: 200px;
    }
  }

  ::slotted([provider='audio']) {
    padding: 30px; // padding to match the playlist component.
    min-height: 200px; // min-height to allow for the overlay text.
    padding-bottom: 0; // remove bottom padding because we are stacking the playlist.
    flex: 1; // stretch the audio player to fill the space.
  }
}

/** Older browsers fallback */
@media (max-width: 782px) {
  .playlist {
    flex-direction: column;

    &__info {
      max-width: none;
      min-height: none;
      width: 100%;

      &--inner {
        flex: 1;
        height: fit-content;
        max-height: var(--presto-playlist-max-height-stacked, 200px);
        min-height: var(--presto-playlist-min-height-stacked, 0);
      }
    }
  }
}